import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fence",
  "use": "icon-fence-usage",
  "viewBox": "0 0 1058 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1058 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fence\"><defs><style type=\"text/css\"></style></defs><path d=\"M154.2 39.3L49.3 208.7v789.2h209.8V208.7zM517.3 39.3L412.4 208.7v789.2h209.8V208.7zM880.4 39.3L775.5 208.7v789.2h209.8V208.7z\" p-id=\"3031\" /><path d=\"M0 257.1h1058.3v83.3H0zM0 811.3h1058.3v83.3H0z\" p-id=\"3032\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol